
export const domain     = state => state.domain
export const pop_up     = state => state.pop_up
export const success    = state => state.success
export const menu       = state => state.menu




